import { debounce } from '../../core/helpers';
import { removeMarketingBlocks } from './actions';

const resizeMarketingBlocks = () => {
  const marketingBlocks = document.querySelectorAll('[data-collection-marketing-block]');
  const productTiles = document.querySelectorAll('.collection-grid-section [data-product-tile]');
  if (!marketingBlocks.length || !productTiles.length) {
    return;
  }

  const firstTileImage = productTiles[0].querySelector('[data-product-tile-image]');
  const image_height = firstTileImage ? firstTileImage.offsetHeight : 0;

  if (image_height > 0) {
    const mainBlocks = document.querySelectorAll('[data-collection-marketing-block].plp-mb--main');
    const mainBlockFormatFull = Array.from(mainBlocks).some(block => block.dataset.format === 'full');

    if (mainBlockFormatFull) {
      document.querySelectorAll('[data-collection-marketing-block].plp-mb--main.hidden--mobile').forEach(block => {
        block.style.minHeight = `${image_height / 2}px`;
      });
      document.querySelectorAll('[data-collection-marketing-block].plp-mb--main.hidden--desktop').forEach(block => {
        block.style.height = `${image_height}px`;
      });
    } else {
      mainBlocks.forEach(block => {
        block.style.height = `${image_height}px`;
      });
    }

    document.querySelectorAll('[data-collection-marketing-block].plp-mb--extra').forEach(block => {
      block.style.height = `${image_height}px`;
    });
  }
};

const initMarketingBlock = () => {
  // Delete the marketing blocks created in liquid if not needed
  removeMarketingBlocks();

  const gridSection = document.querySelector('.collection-grid-section');
  if (!gridSection) return;
  gridSection.addEventListener('click', (e) => {
    const item = e.target.closest('[data-collection-marketing-block]');
    if (!item) return;
    const url = item.dataset.url;
    if (url && url.length) {
      window.location.href = url;
    }
  });
  
  // [ADA] Keypress scoping
  gridSection.addEventListener('keypress', (e) => {
    const item = e.target.closest('[data-collection-marketing-block]');
    if (!item) return;
    if (e.key === 'Enter' || e.key === ' ') {
      const url = item.dataset.url;
      if (url && url.length) {
        window.location.href = url;
      }
    }
  });

  window.addEventListener('resize', debounce(() => {
    resizeMarketingBlocks();
  }, 10));
};

export {
  initMarketingBlock,
  resizeMarketingBlocks,
};
